import React from "react";
import { Radio, Newspaper, ExternalLink } from "lucide-react";
import { LINKS } from "@/lib/brand";

const items = [
  {
    icon: Newspaper,
    outlet: "Solinger Tageblatt",
    type: "Reportage · 2026",
    headline: "Solingerin veröffentlicht Ausmalbuch für Erste Hilfe",
    quote:
      "Hauptfigur Paula soll zeigen, wie auch die ganz Kleinen große Hilfe leisten können.",
    color: "bg-paula-red-soft",
    iconColor: "text-paula-red",
    link: LINKS.solingerTageblatt,
  },
  {
    icon: Radio,
    outlet: "Radio RSG",
    type: "Beitrag",
    headline: "Erste-Hilfe-Ausmalbuch für Kinder aus Solingen",
    quote: "Wie aus einer Pinguindame Mut für Kinder wird.",
    color: "bg-paula-yellow-soft",
    iconColor: "text-paula-yellow",
    link: LINKS.radioRsg,
  },
];

export const Press = () => {
  return (
    <section
      id="presse"
      data-testid="press-section"
      className="relative py-24 sm:py-32 bg-white border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-paula-blue mb-4">
              Presse
            </div>
            <h2 className="font-display font-bold text-4xl sm:text-5xl text-paula-ink leading-[1.05] tracking-tight">
              Was die Presse über{" "}
              <span className="text-paula-red">Paula</span> sagt.
            </h2>
          </div>
          <p className="text-paula-muted max-w-md">
            Berichte aus Funk und Print. Paula spricht viele Sprachen — am
            liebsten die der Kinder.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {items.map((p) => (
            <a
              key={p.outlet}
              href={p.link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`press-card-${p.outlet.toLowerCase().replace(/\s+/g, "-")}`}
              className="group p-8 rounded-3xl bg-paula-cream border border-slate-200 hover:border-paula-ink transition-colors flex flex-col"
            >
              <div className="flex items-center gap-4 mb-6">
                <div
                  className={`w-14 h-14 rounded-2xl ${p.color} grid place-items-center`}
                >
                  <p.icon className={p.iconColor} size={24} />
                </div>
                <div className="flex-1">
                  <div className="text-[10px] uppercase tracking-widest text-paula-muted">
                    {p.type}
                  </div>
                  <div className="font-display font-bold text-xl text-paula-ink">
                    {p.outlet}
                  </div>
                </div>
                <ExternalLink
                  className="text-paula-muted group-hover:text-paula-red transition-colors"
                  size={20}
                />
              </div>
              <div className="font-display font-semibold text-2xl text-paula-ink leading-snug mb-4">
                {p.headline}
              </div>
              <p className="text-paula-muted leading-relaxed italic flex-1">
                „{p.quote}"
              </p>
              <div className="mt-6 pt-6 border-t border-slate-200 text-xs font-semibold text-paula-muted uppercase tracking-widest group-hover:text-paula-red transition-colors">
                Zum Artikel →
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Press;
